import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function quantityLotSizeValidator(lotSize: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value % lotSize !== 0) {
      return { quantityNotMultiple: true };
    }
    return null;
  };
}
